import React from 'react'

import { OptimizelyExperiment } from '@optimizely/react-sdk'
import styled, { css } from 'styled-components'

import { style } from 'theme'

interface SeparatorDivProps {
  mobileCtaSeparator?: boolean
  extraCtaMargin?: boolean
  addMargin?: boolean
  removeHero?: boolean
  extraMargin?: boolean
}

const SeparatorDiv = styled.div<SeparatorDivProps>`
  height: 1px;
  background-color: ${style(theme => theme.colors.ivory)};
  margin: 0px 0px 30px -50px;
  width: calc(100% + 100px);

  ${props =>
    props.removeHero &&
    css`
      height: 0px;
      padding: 0;
      margin-bottom: -10px;
    `}
  ${props => props.removeHero && props.extraMargin && 'margin-bottom: 0;'}

  @media (min-width: ${style(theme => theme.breakpoints.sm)}px) {
    ${props => props.addMargin && 'margin-top: 30px;'}
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    ${props =>
      props.mobileCtaSeparator &&
      css`
        margin-top: 40px;
        margin-bottom: 0px;
        display: block;
        width: 100%;
      `}

    ${props => props.mobileCtaSeparator && props.extraCtaMargin && 'margin-top: 80px;'}
  }
`

const Separator: React.FC<Omit<SeparatorDivProps, 'removeHero'>> = props => (
  <OptimizelyExperiment experiment="growth-1307_remove_hero">
    {variation =>
      variation === 'remove_hero' ? (
        <SeparatorDiv removeHero {...props}>
          {props.children}
        </SeparatorDiv>
      ) : (
        <SeparatorDiv {...props}>{props.children}</SeparatorDiv>
      )
    }
  </OptimizelyExperiment>
)

export default Separator
